import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = '',
    name = '',
    kpiType = 0,
    fund = '',
    assetType = 0,
    layers = 3,
    industryId = '',
    depCateId = [],
    summary = '',
    budgetTotal = 0,
    annualTarget = '',
    order = 0,
    files = [],
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.kpi.save, {
        id,
        name,
        kpiType,
        fund,
        assetType,
        layers,
        industryId,
        depCateId,
        summary,
        budgetTotal,
        annualTarget,
        order,
        files,
    }, options);
    if (error) return { error, status };
    return content || {};
};

